/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { s as setAssetPath$1 } from "./chunks/runtime.js";
import { g } from "./chunks/runtime.js";
let assetPathChanged = false;
const setAssetPath = (path) => {
  assetPathChanged = true;
  setAssetPath$1(path);
};
export {
  assetPathChanged,
  g as getAssetPath,
  setAssetPath
};
